import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  ICompanyDocumentPayload,
  ICompanyDocumentResponse,
  IGetDocumentResponse,
} from "@/interface/companyDocument.interface";

export const CompanyDocumentServices = {
  createCompanyDocument: async (
    payload: ICompanyDocumentPayload,
  ): Promise<ICompanyDocumentResponse> => {
    const API = `${API_ENDPOINT.CompanyDocument}`;
    return callApi<ICompanyDocumentResponse>(API, {
      method: "POST",
      data: payload,
    });
  },

  getCompanyDocuments: async (
    params?: string,
  ): Promise<IGetDocumentResponse> => {
    const API = `${API_ENDPOINT.CompanyDocument}${params ? `?${params}` : ""}`;
    return callApi<IGetDocumentResponse>(API, { method: "GET" });
  },

  getCompanyDocumentById: async (
    id: string,
  ): Promise<ICompanyDocumentResponse> => {
    if (!id) throw new Error("ID is required to fetch document details");
    const API = `${API_ENDPOINT.CompanyDocument}/${id}`;
    return callApi<ICompanyDocumentResponse>(API, { method: "GET" });
  },

  updateCompanyDocument: async (
    payload: ICompanyDocumentPayload,
    id: string,
  ): Promise<ICompanyDocumentResponse> => {
    if (!id) throw new Error("ID is required to update document");
    const API = `${API_ENDPOINT.CompanyDocument}/${id}`;
    return callApi<ICompanyDocumentResponse>(API, {
      method: "PUT",
      data: payload,
    });
  },

  deleteCompanyDocument: async (
    id: string,
  ): Promise<ICompanyDocumentResponse> => {
    if (!id) throw new Error("ID is required to delete document");
    const API = `${API_ENDPOINT.CompanyDocument}/${id}`;
    return callApi<ICompanyDocumentResponse>(API, { method: "DELETE" });
  },
};
